
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.67 36.67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M6.6 9.51H18v8.5H6.6zM18.7 9.51h11.4v8.5H18.7zM6.6 18.66H18v8.5H6.6zM18.7 18.66h11.4v8.5H18.7z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/layoutIcons/layoutFour.svg